import { createSelector } from 'reselect'

const getFolderData = state => state.myLibrary.name_folder_modal
const getParentFolderUID = state => state.myLibrary.folderUID

const myLibraryFolderEditSelector = createSelector(
	[getFolderData, getParentFolderUID],
	(folderData, parentFolderUID) => ({
		...folderData,
		parentFolder: parentFolderUID,
	})
)

export default myLibraryFolderEditSelector
